@use '../../styles/themed' as themed;
@use '../../styles/border' as border;
@use '../../styles/shadow' as shadow;
@use '../../styles/typography' as typography;

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.96);
  }
}

.content {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  border: border.$border-width solid;
  box-shadow: shadow.$shadow-m;
  z-index: 1400;
  outline: none;
  pointer-events: none;
  max-width: 300px;
  transform-origin: var(--radix-tooltip-content-transform-origin);

  &[data-state='delayed-open'] {
    animation: fadeIn 130ms ease-out;
  }

  &[data-state='closed'] {
    animation: fadeOut 100ms ease-out;
  }
}

.contentDark {
  background-color: themed.color(surface-default);
  border-color: themed.color(border-stronger);
}

.contentLight {
  background-color: themed.color(surface-raised);
  border-color: themed.color(border-default);
}

.contentWithHelperText {
  gap: 12px;
}

.text {
  display: flex;
  flex-direction: column;
  padding: 0 4px;
  min-width: 0;
}

.title {
  @include typography.text-m-regular;
  color: themed.color(text-primary);
  text-wrap: pretty;
  overflow-wrap: anywhere;
}

.subtitle {
  @include typography.text-s-regular;
  color: themed.color(text-secondary);
  white-space: pre-line;
  overflow-wrap: break-word;
  text-wrap: pretty;
}

.helperText {
  @include typography.text-m-regular;
  padding: 0 4px;
  flex-shrink: 0;
  color: themed.color(text-tertiary);
}
